module.exports = __webpack_public_path__ + "static/media/companyBgDark.ed7bf242.png";